<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api.js';
    import UserStore from '../stores/user';
    import { validateFields }  from '../base/validation.js';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../components/Header.svelte'; 
    import TopInfo from '../components/TopInfo.svelte';  
    import Preloader from '../components/Preloader.svelte'; 


    let isLoading = false;
    let customers = [];
    let showNewCustomer = false;
    let name = '';
    let email = '';
    let phone = '';
    let company = '';

    onMount(async () => {

        if (!$UserStore || !$UserStore.merchant_id){
            push('/login');
            return;
        } 

        getCustomers();
        
    })





    async function getCustomers() {

        let postData = {};

        isLoading = true;

        postData.action = 'customers';
        postData.token = $UserStore.token
        let response = await fetchData(postData);
        if (response.customers) {  

            customers = response.customers;

        }

        isLoading = false;

    }


    async function addCustomer() {

        let postData = {};

        postData.action = 'add_customer';        
        postData.token = $UserStore.token
        postData.name = name;
        postData.email = email;
        postData.phone = phone;
        postData.company = company;
        let response = await fetchData(postData);
        if (response.success==1) {  
            getCustomers();
            name = '';            
            email = '';
            phone = '';
            company = '';
            showNewCustomer = false;
        }
    }

    async function integrationGetProducts(customer_id) {

        isLoading = true;

        let postData = {};
        postData.action = 'integration_get_products';
        postData.token = $UserStore.token
        postData.customer_id = customer_id
        let response = await fetchData(postData);

        isLoading = false;
    }

    async function integrationSetProducts(customer_id) {

        isLoading = true;

        let postData = {};
        postData.action = 'integration_set_products';
        postData.token = $UserStore.token
        let response = await fetchData(postData);

        isLoading = false;
    }

    async function integrationSetInventory(customer_id) {

        isLoading = true;

        let postData = {};
        postData.action = 'integration_set_inventory';
        postData.token = $UserStore.token
        let response = await fetchData(postData);

        isLoading = false;
    }

    

    

        



        
</script>

<style>
    table td {
        border: 1px solid #000;
        padding:5px
    }
</style>
<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">    
        <TopInfo/>
        <div class="shipment p-5">            
            <h1 class="text-[20px] font-bold">
                {$_('customers.title')}
            </h1>    
            
            <div class="shipment-flex">
                <div class="shipment_origin">                           
                    <div class="">
                        {#if !customers.length}
                        <div class="mb-5 mt-5 bg-slate-100 border-slate-200 border-[1px] p-5 rounded-[5px]">                            
                            {$_('customers.not_found')}
                        </div>
                        {:else}
                        <div class="mb-5 mt-5 p-5 flex justify-between align-center">                            
                            <div>{$_('customers.customers')}</div>
                            <div>
                                <button on:click={() => showNewCustomer = !showNewCustomer } class="bg-red-100 border-slate-200 border-[1px] p-2 rounded-[5px]">
                                    {$_('customers.add_new_customer')}
                                </button>
                            </div>
                        </div>
                        {#if showNewCustomer}
                        <div>
                            <div class="mb-5 mt-5 bg-slate-100 border-slate-200 border-[1px] p-5 rounded-[5px]">
                                <div class="flex gap-2">
                                    <div class="w-1/2">
                                        <input type="text" placeholder="name" bind:value={name} class="w-full">
                                    </div>
                                    <div class="w-1/2">                                    
                                        <input type="text" placeholder="company" bind:value={company} class="w-full">
                                    </div>                                    
                                </div>
                                <div class="flex gap-2 mt-2">
                                    <div class="w-1/2">
                                        <input type="text" placeholder="phone" bind:value={phone} class="w-full">
                                    </div> 
                                    <div class="w-1/2">
                                        <input type="text" placeholder="email" bind:value={email} class="w-full">
                                    </div>    
                                </div>
                                <div class="flex justify-end">
                                    <button on:click={()=>addCustomer()} class="bg-red-400 border-slate-200 border-[1px] p-2 rounded-[5px]">
                                        {$_('customers.add_customer')}
                                    </button>
                                </div>
                            </div>
                        </div>
                        {/if}
                        <div>
                            <table class="w-full">
                                <tr>
                                    <td class="font-bold bg-slate-100">{$_('customers.company')}</td>
                                    <td class="font-bold bg-slate-100">{$_('customers.name')}</td>
                                    <td>
                                        <button on:click={()=> { integrationSetProducts() } } class="bg-red-500 border-slate-200 border-[1px] p-2 rounded-[5px]">
                                        {$_('customers.sync_to_my_store_products')}
                                        </button>
                                        <button on:click={()=> { integrationSetInventory() } } class="bg-red-500 border-slate-200 border-[1px] p-2 rounded-[5px]">
                                            {$_('customers.sync_to_my_store_stock')}
                                        </button>

                                        
                                    </td>
                                </tr>
                                {#each customers as item,index}
                                <tr>
                                    <td>{item.company}</td>
                                    <td>{item.firstname} {item.lastname}</td>
                                    <td class="flex justify-end">
                                        <button on:click={()=> { push(`/customers/${item.merchant_id}`) } } class="bg-red-400 border-slate-200 border-[1px] p-2 rounded-[5px]">
                                        {$_('customers.edit')}
                                        </button>

                                        <button on:click={()=> { integrationGetProducts(item.merchant_id) } } class="bg-red-400 border-slate-200 border-[1px] p-2 rounded-[5px]">
                                        {$_('customers.sync')}
                                        </button>
                                    </td>
                                </tr>
                                {/each}
                            </table>
                        </div>
                        {/if}
                                         
                    </div>
                </div> 
            </div> 
        </div>
        
    </div>
</div>

